import Carrying from './carrying';

export default class QuoteList {
  public carriers?: Array<Carrying>;
  public tokenOffer?: string;
}
